// extracted by mini-css-extract-plugin
export default {"container":"IDYfZ0","suspend":"ri6En6 HsV6Lx mz-button-primary elqoUp mz-button-default fnhZ6v qRatTb Jrs8xB RdC3lD"};